import React from "react";

const Test = () => {
  return (
    <div className="mx-5 space-y-4">
      <a href="https://fileswift-server.onrender.com/file/66939a6fa8ac7aa28915fab0">
        Download
      </a>
      <hr />
      <div
        contentEditable
        className="mx-48  text-center border border-black px-5"
      >
        "This is a div contains the attribute contentEditable. You can edit the
        contents it have."
      </div>
      <hr />
      <div>
        <div>Who is the PM of India?</div>
        <details>
          <summary></summary>Mr. Narendra Modi
        </details>
      </div>
      <hr />
      <div title="Hi! I am Title.">Hover on me...</div>
      <hr />
      <div>Blog Post</div>
      <blockquote cite="https://www.w3schools.com/tags/att_blockquote_cite.asp">
        The cite attribute does not render as anything special in any of the
        major browsers, but it can be used by search engines to get more
        information about the quotation.
      </blockquote>
      <hr />
      <div>
        <label htmlFor="file">Progress bar:</label>
        <progress id="file" value="50" max="100">
          50%
        </progress>
      </div>
      <hr />
      <div>
        <label htmlFor="browser">Choose your browser from the list:</label>
        <input
          list="browsers"
          name="browser"
          id="browser"
          placeholder="Select"
          className="px-2 mx-2 border border-black"
        />
        <datalist id="browsers">
          <option value="Edge" />
          <option value="Firefox" />
          <option value="Chrome" />
          <option value="Opera" />
          <option value="Safari" />
        </datalist>
      </div>
      <hr />
    </div>
  );
};

export default Test;
